import BrandLogo from "../../assets/images/brand-logo.svg";
import { SSO_URL } from "../../config";

const Login = () => {

  const handleSSO = () => {
    // Redirect to the IdP SSO URL
    window.location.href = `${SSO_URL}`;
  };

  return (
    <div className="loginContainer">
      <div className="loginContent">
        <img src={BrandLogo} alt="Roche Logo" className="logo" />
        <h1 className="title">Text Sentinel</h1>
        <button
          className="loginButton"
          onClick={handleSSO}
        >
          Sign in via SSO (for Roche employees)
        </button>
      </div>
    </div>
  );
};

export default Login;
